import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TrnAdmissionService} from '../../configuration/trn-admission/trn-admission.service';
import {MipdDischargeTemplateService} from '../../configuration/mipd-discharge-template/mipd-discharge-template.service';
import {ToastsManager} from 'ng2-toastr';
import {DischargeSummaryService} from './discharge-summary.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DatepickerConfig} from '../../shared/custom-service/datepicker-configuration.service';

declare var $: any;

@Component({
  selector: 'app-discharge-summary',
  templateUrl: './discharge-summary.component.html',
  styleUrls: []
})
export class DischargeSummaryComponent implements OnInit {
  AddForm: FormGroup;
  selectedadmissionid: any;
  patientList: Array<any> = [];
  templatelist: Array<any> = [];
  templateparameterlist: Array<any> = [];
  selectedparameterlist: Array<any> = [];
  selectedpatient: any;
  datePickerConfig: any;
  dateObject: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    vcr: ViewContainerRef,
    private fb: FormBuilder,
    public toastr: ToastsManager,
    private TrnAdmissionService: TrnAdmissionService,
    private MipdDischargeTemplateService: MipdDischargeTemplateService,
    private DischargeSummaryService: DischargeSummaryService
  ) {
    this.datePickerConfig = DatepickerConfig;
    this.toastr.setRootViewContainerRef(vcr);
    this.AddForm = fb.group({
      'dsAdmissionID': fb.group({
        'admissionId': [null, Validators.required]
      }),
      'followupDate': [null],
      'followupDatePersion': [null]
    });
  }

  ngOnInit() {
    this.dateObject = '';
    this.MipdDischargeTemplateService.gettemplatelist().then(resp => this.templatelist = resp.record);
  }

  getdischargedescription(event: any) {
    // console.log(event)
    this.selectedparameterlist.push({dsFieldName: event.target.name, dsFieldDesacription: event.target.value});
  }

  onAdd(model: any) {
    for (let singlesummary of this.selectedparameterlist) {
      model.dsFieldName = singlesummary.dsFieldName;
      model.dsFieldDesacription = singlesummary.dsFieldDesacription;
      this.DischargeSummaryService.addRecordService(model).then(resp => {
        if (resp.success === '1') {
          this.toastr.success(resp.msg, 'Success ! ');
        }
        else {
          this.toastr.error(resp.msg, 'Failed ! ');
        }
      });
    }
    this.router.navigate(['/ipd/dischargelist']);
  }

  AddRecord(model: any) {
    let result;
    // console.log(this.selectedadmissionid);
    // console.log(this.selectedparameterlist);
    for (let singlesummary of this.selectedparameterlist) {
      model.dsAdmissionID.admissionId = this.selectedadmissionid;
      model.dsFieldName = singlesummary.dsFieldName;
      model.dsFieldDesacription = singlesummary.dsFieldDesacription;
      model.dsFieldDesacription = singlesummary.dsFieldDesacription;
      this.TrnAdmissionService.addRecordService(model).then(resp => {
        result = resp;
      });
    }
    return result;
  }

  showDate() {
    this.AddForm.controls.followupDate.setValue(this.dateObject);
    this.AddForm.controls.followupDatePersion.setValue(this.dateObject);
  }

  gettemplatebyname(templatename: any) {
    this.MipdDischargeTemplateService.getRecordServicebytemplatename(templatename).then(resp => {
      let array;
      for (let m of resp) {
        if (m.dtCountrolvalue != null) {
          array = m.dtCountrolvalue.split(',');
        }
        m.dtCountrolvalue = array;
        this.templateparameterlist.push(m);
      }
      // console.log(this.templateparameterlist);
    });
  }

  onChangeMrNo(event: any) {
    this.selectedpatient = event;
    this.selectedadmissionid = event.admissionId;
    this.AddForm.controls.dsAdmissionID.get('admissionId').setValue(event.admissionId);
    // console.log(event);
  }

  searchPatientByMrno(event) {
    let qString: string = event.query;
    this.TrnAdmissionService.getmrnoautocomplite(qString).then(
      resp => {
        // console.log(resp);
        this.patientList = resp.record;
      });
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/discharge-summary/discharge-summary.component.ts